import {useState} from "react";
import {Tag} from "antd";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import style from "../style/SeoCheck.module.scss";

const cn = className.bind(style);

/**
 * Xem nhanh thông tin craw được: URL, SSL, mã trạng thái, title, description,
 * số từ, canonical, ngôn ngữ, liên kết, loại schema và link tới mã nguồn HTML.
 */
function CrawlSummary({meta}) {

	const [showMeta, setShowMeta] = useState(false);

	if (!meta) return null;

	const rawMeta = meta.all_meta_tags || [];

	const rows = [
		{label: 'URL', value: meta.url ? <a href={meta.url} target="_blank" rel="noreferrer">{meta.url}</a> : '—'},
		{label: 'Tiêu đề', value: meta.title || '—'},
		{label: 'Mô tả', value: meta.description || '—'},
		{label: 'Ngôn ngữ', value: meta.lang || '—'},
		{label: 'hreflang', value: meta.hreflang?.length ? meta.hreflang.join(', ') : '—'},
		{label: 'Canonical', value: meta.canonical || '—'},
		{label: 'Số từ nội dung', value: meta.word_count ?? '—'},
		{label: 'Tỷ lệ text/HTML', value: meta.text_html_ratio != null ? `${meta.text_html_ratio}%` : '—'},
		{label: 'Liên kết', value: `${meta.internal_links ?? 0} nội bộ / ${meta.external_links ?? 0} ngoài / ${meta.nofollow_links ?? 0} nofollow`},
		{label: 'Tổng thẻ meta', value: meta.total_meta_tags ?? '—'},
	];

	return (
		<div className={cn('summary')}>
			<div className={cn('summary-tags')}>
				<Tag color={meta.ssl ? 'green' : 'red'}>{meta.ssl ? 'HTTPS' : 'Không HTTPS'}</Tag>
				<Tag color={meta.status_code >= 200 && meta.status_code < 300 ? 'green' : 'orange'}>
					HTTP {meta.status_code || '—'}
				</Tag>
				<Tag color={meta.favicon ? 'green' : 'default'}>{meta.favicon ? 'Có favicon' : 'Thiếu favicon'}</Tag>
				<Tag color={meta.robots_txt ? 'green' : 'default'}>robots.txt</Tag>
				<Tag color={meta.sitemap ? 'green' : 'default'}>sitemap</Tag>
				{meta.amp && <Tag color="purple">AMP</Tag>}
				{(meta.schema_types || []).map((t) => <Tag key={t} color="blue">{t}</Tag>)}
			</div>

			<dl className={cn('summary-list')}>
				{rows.map((r) => (
					<div className={cn('summary-row')} key={r.label}>
						<dt>{r.label}</dt>
						<dd>{r.value}</dd>
					</div>
				))}
			</dl>

			{rawMeta.length > 0 && (
				<div className={cn('summary-rawmeta')}>
					<button type="button" className={cn('details-toggle')} onClick={() => setShowMeta(!showMeta)}>
						<FontAwesomeIcon icon={showMeta ? 'fa-light fa-chevron-down' : 'fa-light fa-chevron-right'} />
						{showMeta ? 'Ẩn thẻ meta thô' : `Xem thẻ meta thô (${rawMeta.length})`}
					</button>
					{showMeta && (
						<ul className={cn('rawmeta-list')}>
							{rawMeta.map((tag, i) => <li key={i}><code>{tag}</code></li>)}
						</ul>
					)}
				</div>
			)}

			{meta.source && (
				<a className={cn('summary-source')} href={meta.source} target="_blank" rel="noreferrer">
					<FontAwesomeIcon icon="fa-light fa-file-code" /> Xem mã nguồn HTML đã craw
				</a>
			)}
		</div>
	);
}

export default CrawlSummary;
